import Axios from "axios";
import Moment from "moment";
import ZwxCookie from "./cookie";
import ZwxSm from "./sm";
import FileSaver from "file-saver";
import { v4 as uuidv4 } from "uuid";
import XLSX from "xlsx";
import XLSXS from "xlsx-style";

import { filterNullOrUndefined, paramsFormat, isLocalhost } from "./finals";

Moment.locale("zh-cn");

/**
 * 最高层级有效窗口对象
 * */
let windowTop = () => {
  return window.top === undefined || window.top === null || window.top.vm === undefined || window.top.vm === null ? window : window.top;
};

/**
 * post请求
 * */
let post = (url, data, isTokenId, isSign, success, error, other) => {
  const dateNow = Date.now() + Number(ZwxCookie.getCookieDefault("internetTimeDiff", 0));
  // post自定义header请求
  postCusHeaders(url, data, httpHeader(isTokenId, dateNow), isSign, dateNow, success, error, other);
};

/**
 * get请求
 * */
let get = (url, data, isTokenId, isSign, success, error, other) => {
  const dateNow = Date.now() + Number(ZwxCookie.getCookieDefault("internetTimeDiff", 0));
  // get自定义header请求
  getCusHeaders(url, data, httpHeader(isTokenId, dateNow), isSign, dateNow, success, error, other);
};

/**
 * postJson请求
 * */
let postJson = (url, data, isTokenId, isSign, success, error, other) => {
  const dateNow = Date.now() + Number(ZwxCookie.getCookieDefault("internetTimeDiff", 0));
  // postJson自定义header请求
  postJsonCusHeaders(url, data, httpHeader(isTokenId, dateNow), isSign, dateNow, success, error, other);
};

let createExportExcelFilterData = (data) => {
  const clonedData = JSON.parse(JSON.stringify(data));
  const filterData = filterNullOrUndefined(clonedData, false);
  return filterData;
};

let createExportExcelTicket = (url, filterData, headers) => {
  headers = createTicket(false, url, filterData, headers);
  return headers;
};

let createTicket = (isParams, url, filterData, headers) => {
  if (!isLocalhost(url)) {
    // body + ':' + params
    const params = paramsFormat(isParams, url, filterData);
    // 签名
    if (!headers) {
      headers = {};
    }
    if (!headers.noTokenSign) headers["tokenSign"] = ZwxSm.sm2Encrypt123(ZwxSm.sm3Encrypt(params));
    if (Object.hasOwn(headers, "noTokenSign")) delete headers.noTokenSign;
  }
  return headers;
};

/**
 * post自定义header请求
 * */
let postCusHeaders = (url, data, headers, isSign, dateNow, success, error, other) => {
  url = url + (url.indexOf("?") === -1 ? "?ms=" + dateNow : "&ms=" + dateNow);
  //httpData(data)
  const clonedData = JSON.parse(JSON.stringify(data));
  const isParams = true;
  const filterData = filterNullOrUndefined(clonedData, isParams);
  headers = createTicket(isParams, url, filterData, headers);
  Axios.post(url, undefined, { params: filterData, headers: headers })
    .then(response => httpSuccess(dateNow, response, isSign, success, error, other))
    .catch(() => {
      if (error) error(other);
    });
};

/**
 * get自定义header请求
 * */
let getCusHeaders = (url, data, headers, isSign, dateNow, success, error, other) => {
  url = url + (url.indexOf("?") === -1 ? "?ms=" + dateNow : "&ms=" + dateNow);
  //httpData(data)
  const clonedData = JSON.parse(JSON.stringify(data));
  const isParams = true;
  const filterData = filterNullOrUndefined(clonedData, isParams);
  headers = createTicket(isParams, url, filterData, headers);
  Axios.get(url, { params: filterData, headers: headers })
    .then(response => httpSuccess(dateNow, response, isSign, success, error, other))
    .catch(() => {
      if (error) error(other);
    });
};

/**
 * postJson自定义header请求
 * */
let postJsonCusHeaders = (url, data, headers, isSign, dateNow, success, error, other) => {
  url = url + (url.indexOf("?") === -1 ? "?ms=" + dateNow : "&ms=" + dateNow);
  const clonedData = JSON.parse(JSON.stringify(data));
  const isParams = false;
  const filterData = filterNullOrUndefined(clonedData, isParams);
  headers = createTicket(isParams, url, filterData, headers);
  Axios.post(url, filterData, { headers: headers })
    .then(response => httpSuccess(dateNow, response, isSign, success, error, other))
    .catch(() => {
      if (error) error(other);
    });
};

/**
 * 获取cookie中无国密tokenId的header
 * */
let noSmTokenIdHeader = () => {
  return { tokenId: ZwxCookie.getCookie("zwxToken") };
};

/**
 * 在head中动态添加script标签
 * */
let addHeadScript = (script, callback) => {
  if (script === undefined) return;
  let scriptElement = document.createElement("script");
  scriptElement.setAttribute("type", "text/javascript");
  scriptElement.setAttribute("src", script);
  if (callback !== undefined) {
    scriptElement.addEventListener("load", callback, false);
  }
  document.head.appendChild(scriptElement);
};

// 通用型接口调用
let commonApi = (interfacetype = "get", url, params = {}, that, bool = true, boolean = true) => {
  that.$emit("loading", true);
  return new Promise(
    (resolve, reject) => {
      that.$system[interfacetype](that.api + url, params, bool, boolean, data => {
        if (data.type === "00") {
          resolve(data);
        } else if (data.type === "99") {
          that.$router.push({ name: "MsError", params: { mess: data.mess } });
        } else {
          reject(false);
          that.$system.notify("错误", data.mess, "error");
        }
        that.$emit("loading", false);
      });
    },
    that.error,
    { that }
  );
};

/**
 * 上传文件
 * */
let uploadFile = (url, formData, success, error, other) => {
  Axios.post(url, formData, { headers: { "Content-Type": "multipart/form-data" } })
    .then(response => httpSuccess(undefined, response, false, success, error, other))
    .catch(() => {
      if (error) error(other);
    });
};

/**
 * 下载url文件，并重命名
 * */
let downloadUrlFile = (fileName, url) => {
  if (fileName === undefined || url === undefined) return;
  const dateNow = Date.now() + Number(ZwxCookie.getCookieDefault("internetTimeDiff", 0));
  url = url + (url.indexOf("?") === -1 ? "?ms=" + dateNow : "&ms=" + dateNow);
  let data = {};
  const clonedData = JSON.parse(JSON.stringify(data));
  const isParams = true;
  const filterData = filterNullOrUndefined(clonedData, isParams);
  let headers = {};
  headers = createTicket(isParams, url, filterData, headers);
  Axios.get(url, { params: {}, headers: headers, responseType: "blob" }).then(response => {
    if (!fileName) {
      const match = response.headers["content-disposition"].match(/filename=([^;]+)/);
      fileName = decodeURIComponent(match[1]);
    }
    FileSaver.saveAs(response.data, fileName);
  });
};

/**
 * 将内容转化成文件后下载
 * */
let downloadContentFile = (fileName, content) => {
  if (fileName === undefined || content === undefined) return;
  let blob = new Blob([content]);
  FileSaver.saveAs(blob, fileName);
};

/**
 * 浏览器打开新的tab
 * */
let windowOpenBlank = url => {
  windowTop().open(url, "_blank");
};

/**
 * 确认取消弹框
 * action == 'cancel'：取消
 * action == 'close'：关闭
 * */
let msgbox = (data, title, content, confirmButton, cancelButton, success, closeOrCancel) => {
  windowTop()
    .vm.$msgbox({
    title: title,
    message: content,
    confirmButtonText: confirmButton,
    showCancelButton: cancelButton !== undefined && cancelButton !== null && cancelButton !== "",
    cancelButtonText: cancelButton,
    type: "warning",
    distinguishCancelAndClose: true,
    dangerouslyUseHTMLString: true
  })
    .then(() => success(data))
    .catch((action) => {
      //判定接收到的数据是一个函数
      if (typeof closeOrCancel === "function") {
        closeOrCancel(action);
      }
    });
};

/**
 * table的操作列最后一列最小宽度计算
 * */
let calMinWidth = options => {
  if (options.wordNum === undefined || options.arrowNum === undefined || options.btnNum === undefined) {
    return 0;
  }
  return options.wordNum * 15 + options.arrowNum * 14 + (options.btnNum - 1) * 10 + 28;
};

/**
 * table的操作列宽度自适应
 * dataList：对应el-table的data参数
 * prop：对应el-table-column的prop参数
 * label：对应el-table-column的label参数
 * extraWord：最长的额外字符串
 * maxWidth：width的最大值
 * */
let calWidth = (dataList, prop, label, extraWord, maxWidth) => {
  if (dataList === undefined || dataList === null || prop === undefined || label === undefined) {
    return 0;
  }
  let width = calStrLength(label);
  for (let i = 0, length = dataList.length; i < length; i++) {
    const obj = calWidthProp(dataList[i], prop);
    if (obj === undefined) continue;
    const propLength = extraWord !== undefined ? calStrLength(obj.toString() + extraWord) : calStrLength(obj.toString());
    if (propLength > width) width = propLength;
  }
  width += 28;
  if (maxWidth !== undefined && width > maxWidth) width = maxWidth;
  return width;
};

/**
 * 验证表单并提交
 * */
let valid = (ref, title, content, confirmButton, cancelButton, success) => {
  ref.validate(valid => {
    if (valid) {
      windowTop()
        .vm.$msgbox({
        title: title,
        message: content,
        confirmButtonText: confirmButton,
        showCancelButton: cancelButton !== undefined && cancelButton !== null && cancelButton !== "",
        cancelButtonText: cancelButton,
        type: "warning"
      })
        .then(() => success())
        .catch(() => {
        });
    } else {
      window.vm.$nextTick(() => {
        const isErrorList = document.getElementsByClassName("el-form-item is-error");
        if (isErrorList === undefined || isErrorList === null || isErrorList.length === 0) return;
        isErrorList[0].scrollIntoView(true);
      });
    }
  });
};

/**
 * 右上角提示信息
 * */
let notifyPromise = Promise.resolve();
let notify = (title, content, type) => {
  const contents = content.split("$@$");
  for (let i = 0, length = contents.length; i < length; i++) {
    ;(function(i) {
      notifyPromise = notifyPromise.then(windowTop().vm.$nextTick).then(() => {
        windowTop().vm.$notify({
          title: title,
          message: contents[i],
          type: type,
          duration: type === "success" || contents[i] === "网络连接失败" ? 1400 : 3000
        });
      });
    })(i);
  }
};

/**
 * 中间提示信息
 * */
let messagePromise = Promise.resolve();
let message = (content, type) => {
  const contents = content.split("$@$");
  for (let i = 0, length = contents.length; i < length; i++) {
    ;(function(i) {
      messagePromise = messagePromise.then(windowTop().vm.$nextTick).then(() => {
        windowTop().vm.$message({
          message: contents[i],
          type: type,
          duration: type === "success" || contents[i] === "网络连接失败" ? 1400 : 5400
        });
      });
    })(i);
  }
};

/**
 * 地区编码截取
 * */
let subZoneCode12 = (zoneCode12, zoneType) => {
  if (zoneCode12 === undefined || zoneCode12 === null || zoneType === undefined || zoneType === null) {
    return null;
  }
  if (zoneType === 0) {
    return "";
  }
  if (zoneType === 1) {
    return zoneCode12.substring(0, 2);
  }
  if (zoneType === 2) {
    return zoneCode12.substring(0, 4);
  }
  if (zoneType === 3) {
    if (zoneCode12.substring(4, 6) === "00") {
      return zoneCode12.substring(0, 9);
    }
    return zoneCode12.substring(0, 6);
  }
  if (zoneType === 4) {
    if (zoneCode12.substring(4, 6) === "00") {
      return zoneCode12;
    }
    return zoneCode12.substring(0, 9);
  }
  return zoneCode12;
};

/**
 * 格式化日期
 * YYYY-MM-DD HH:mm:ss
 * num为多少unit之前，和unit共同使用，如：多少天之前，unit：months、days、years
 * */
let formatDate = (date, format, num, unit) => {
  if (date === undefined || date === null || date === "" || format === undefined || format === null) {
    return "";
  }
  const moment = Moment(date);
  if (num !== undefined && num !== null && num !== "" && unit !== undefined && unit !== null && unit !== "") {
    moment.subtract(num, unit);
  }
  return moment.format(format);
};

/**
 * 生成uuid
 * */
let uuid = () => {
  return uuidv4().replace(/-/g, "");
};

/**
 * 是否是移动端
 * */
let isMobile = () => {
  let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
  return flag !== undefined && flag !== null;
};

/**
 * excel导出
 * fileName：文件名称
 * sheetName：sheet名称
 * aoa：信息点，二维数组
 * merges：单元格合并，数组，示例：[{ s: { r: 0, c: 0 }, e: { r: 0, c: 2 } }]
 * styles：样式，数组，示例：[{ A3: { font: { sz: 14, bold: true, color: { rgb: 'ffffff' } }, alignment: { horizontal: 'center', vertical: 'center' }, fill: { bgColor: { rgb: 'e8e8e8' } }, border: { top: { style: 'thin' }, left: { style: 'thin' }, right: { style: 'thin' }, bottom: { style: 'thin' } } } }]
 * 合并单元格的不能设置边框，可以设置与其相邻的单元格的边框
 * ifAllBorder：是否都加上border
 * */
let excelAoaTo = (fileName, sheetName, aoa, merges, styles, ifAllBorder) => {
  let sheet = XLSX.utils.aoa_to_sheet(aoa);
  if (merges !== undefined && merges !== null && merges.length > 0) sheet["!merges"] = merges;
  sheetStyles(sheet, styles);
  sheetColsWpx(sheet);
  if (ifAllBorder) sheetBorder(sheet);
  downloadContentFile(fileName, sheet2blob(sheet, sheetName));
};

/**
 * excel导出
 * fileName：文件名称
 * sheetName：sheet名称
 * doc：表格的dom元素，示例：document.getElementsByClassName('zwx-table')[0]
 * styles：样式，数组，示例：[{ A3: { font: { sz: 14, bold: true, color: { rgb: 'ffffff' } }, alignment: { horizontal: 'center', vertical: 'center' }, fill: { bgColor: { rgb: 'e8e8e8' } }, border: { top: { style: 'thin' }, left: { style: 'thin' }, right: { style: 'thin' }, bottom: { style: 'thin' } } } }]
 * ifAllBorder：是否都加上border
 * */
let excelTableTo = (fileName, sheetName, doc, styles, ifAllBorder) => {
  let table = sheetTable(doc);
  let sheet = XLSX.utils.table_to_sheet(table);
  sheetStyles(sheet, styles);
  sheetColsWpx(sheet);
  if (ifAllBorder) sheetBorder(sheet);
  downloadContentFile(fileName, sheet2blob(sheet, sheetName));
};

export default {
  windowTop,
  post,
  get,
  postJson,
  postCusHeaders,
  getCusHeaders,
  postJsonCusHeaders,
  noSmTokenIdHeader,
  commonApi,
  addHeadScript,
  uploadFile,
  downloadUrlFile,
  downloadContentFile,
  windowOpenBlank,
  msgbox,
  calMinWidth,
  calWidth,
  valid,
  notify,
  message,
  subZoneCode12,
  formatDate,
  uuid,
  isMobile,
  excelAoaTo,
  excelTableTo,
  createExportExcelTicket,
  createExportExcelFilterData
};

/**
 * 获取tokenId的header
 * */
let httpHeader = (isTokenId, dateNow) => {
  let header = undefined;
  if (isTokenId) {
    header = { tokenId: ZwxSm.sm2Encrypt123(ZwxSm.sm2Decrypt123(ZwxCookie.getCookie("zwxToken")) + "," + dateNow) };
  }
  return header;
};

/**
 * 清除data中为null的参数
 * */
let httpData = data => {
  if (!data && data !== null) {
    for (let item in data) {
      if (data[item] === null) data[item] = undefined;
    }
  }
};

/**
 * 请求成功
 * */
let httpSuccess = (requestStart, response, isMsSign, success, error, other) => {
  if (response.status === 200) {
    const internetTimeDiff = httpInternetDiff(requestStart);
    if (isMsSign) {
      httpSuccessSign(response, internetTimeDiff, success, error, other);
    } else {
      if (response.data.type === "96") {
        if (error) error(other);
      } else if (response.data.type === "97") {
        ZwxCookie.delCookie("internetTimeDiff");
        window.location.reload();
      } else if (response.data.type === "98") {
        if (!ZwxCookie.getCookie("zwxToken")) return;
        ZwxCookie.delCookie("zwxToken");
        alert("您的登录信息已经过期，请重新登录！！！\n或\n您的账号在另一地点登录，您被强制下线！！！\n如果不是本人操作，建议您修改密码！！！");
        window.top.location.reload();
      } else {
        timeDiffSet(response, internetTimeDiff);
        success(response.data, other);
      }
    }
  }
};

/**
 * 请求成功且需要验证国密2
 * */
let httpSuccessSign = (response, internetTimeDiff, success, error, other) => {
  // 验证请求接口消耗时间为15s之内
  if (!response.data.msSign || !response.data.ms || internetTimeDiff > 60000) {
    if (error) error(other);
    return;
  }
  // 验证国密2
  let sign = response.data.msSign;
  delete response.data.msSign;
  if (!ZwxSm.sm2Check123(JSON.stringify(response.data), sign)) {
    if (error) error(other);
    return;
  }
  if (response.data.type === "96") {
    if (error) error(other);
  } else if (response.data.type === "97") {
    ZwxCookie.delCookie("internetTimeDiff");
    window.location.reload();
  } else if (response.data.type === "98") {
    if (!ZwxCookie.getCookie("zwxToken")) return;
    ZwxCookie.delCookie("zwxToken");
    alert("您的登录信息已经过期，请重新登录！！！\n或\n您的账号在另一地点登录，您被强制下线！！！\n如果不是本人操作，建议您修改密码！！！");
    window.top.location.reload();
  } else {
    timeDiffSet(response, internetTimeDiff);
    success(response.data, other);
  }
};

/**
 * 计算网络请求时间差
 * */
let httpInternetDiff = requestStart => {
  return requestStart ? Date.now() + Number(ZwxCookie.getCookieDefault("internetTimeDiff", 0)) - requestStart : 0;
};

/**
 * 将计算网络请求时间差至于time接口返回data中
 * */
let timeDiffSet = (response, internetTimeDiff) => {
  if (response.request.responseURL.indexOf("/time?ms=") !== -1) {
    response.data.internetTimeDiff = internetTimeDiff;
  }
};

/**
 * 获取prop对象
 * */
let calWidthProp = (data, prop) => {
  if (prop === undefined || prop === null || prop === "") return data;
  let propList = prop.split(".");
  if (propList === undefined || propList === null) return undefined;
  let obj = data;
  for (let i = 0, length = propList.length; i < length; i++) {
    obj = obj[propList[i]];
    if (obj === undefined || obj === null) return undefined;
  }
  return obj;
};

/**
 * 计算字符串的长度
 * */
let calStrLength = str => {
  let length = 0;
  const document = windowTop().document;
  let html = document.createElement("span");
  const className = "ms-cal-str-length" + uuid();
  html.innerText = str;
  html.className = className;
  html.style = "font-size: 14px; font-weight: 400; font-family: PingFangSC, PingFangSC-Regular;";
  document.querySelector("body").appendChild(html);
  length = document.querySelector("." + className).offsetWidth + 2;
  document.querySelector("." + className).remove();
  return length;
};

/**
 * sheet去除table的一些class
 * */
let sheetTable = doc => {
  let table = doc.cloneNode(true);
  if (table.getElementsByClassName("el-table__fixed-right") !== undefined && table.getElementsByClassName("el-table__fixed-right").length > 0) table.removeChild(table.getElementsByClassName("el-table__fixed-right")[0]);
  if (table.getElementsByClassName("el-table__fixed") !== undefined && table.getElementsByClassName("el-table__fixed").length > 0) table.removeChild(table.getElementsByClassName("el-table__fixed")[0]);
  let tableHeader = table.getElementsByClassName("el-table__header-wrapper");
  if (tableHeader === undefined || tableHeader.length === 0 || tableHeader[0].getElementsByClassName("gutter") === undefined || tableHeader[0].getElementsByClassName("gutter").length === 0) return table;
  for (let i = 0, length = tableHeader[0].getElementsByClassName("gutter").length; i < length; i++) {
    tableHeader[0].getElementsByClassName("gutter")[0].remove();
  }
  return table;
};

/**
 * sheet设置样式
 * */
let sheetStyles = (sheet, styles) => {
  if (styles === undefined || styles === null || styles.length === 0) return;
  for (let i = 0, length = styles.length; i < length; i++) {
    for (const key in styles[i]) {
      if (sheet[key] === undefined) sheet[key] = {};
      sheet[key].s = styles[i][key];
    }
  }
};

/**
 * sheet计算列宽
 * */
let sheetColsWpx = sheet => {
  let cols = [];
  let colsWords = {};
  for (let key in sheet) {
    if (key.indexOf("!") === 0 || sheet[key].v === undefined) continue;
    const col = key.replace(/[0-9]/gi, "");
    if (cols.indexOf(col) === -1) cols.push(col);
    let fontSize = 12;
    if (sheet[key].s !== undefined && sheet[key].s.font !== undefined && sheet[key].s.font.sz !== undefined) fontSize = sheet[key].s.font.sz;
    const wpx = (sheetColsWpxStrLength(sheet[key].v) * fontSize) / 12;
    if (colsWords[col] === undefined || colsWords[col] < wpx) colsWords[col] = wpx;
  }
  if (cols.length === 0) return;
  for (let i = 0, length = cols.length; i < length; i++) {
    const wpx = colsWords[cols[i]] * 1.27;
    if (sheet["!cols"] === undefined) sheet["!cols"] = [];
    sheet["!cols"].push({ wpx: wpx === 0 ? 63 : wpx });
  }
};

/**
 * sheet计算列宽计算字符串的长度
 * */
let sheetColsWpxStrLength = str => {
  let length = 0;
  const document = windowTop().document;
  let html = document.createElement("span");
  const className = "ms-sheet-cols-wpx-str-length" + uuid();
  html.innerText = str;
  html.className = className;
  html.style = "font-size: 12px; font-weight: 400;";
  document.querySelector("body").appendChild(html);
  length = document.querySelector("." + className).offsetWidth;
  document.querySelector("." + className).remove();
  return length;
};

/**
 * sheet加border
 * */
let sheetBorder = sheet => {
  let cols = [];
  let colNums = [];
  for (let key in sheet) {
    if (key.indexOf("!") === 0 || sheet[key].v === undefined) continue;
    const col = key.replace(/[0-9]/gi, "");
    if (cols.indexOf(col) === -1) cols.push(col);
    const nums = key.replace(/[^0-9]/gi, "");
    if (colNums.indexOf(nums) === -1) colNums.push(nums);
  }
  if (cols.length === 0 || colNums.length === 0) return;
  for (let index in cols) {
    for (let i = 0; i < colNums[colNums.length - 1]; i++) {
      if (sheet[cols[index] + (i + 1)] === undefined) sheet[cols[index] + (i + 1)] = {};
      if (sheet[cols[index] + (i + 1)].s === undefined) sheet[cols[index] + (i + 1)].s = {};
      sheet[cols[index] + (i + 1)].s.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
        bottom: { style: "thin" }
      };
    }
  }
};

/**
 * sheet转blob
 * */
let sheet2blob = (sheet, sheetName) => {
  let workbook = {
    SheetNames: [sheetName],
    Sheets: {}
  };
  workbook.Sheets[sheetName] = sheet;
  const wopts = { bookType: "xlsx", bookSST: false, type: "binary" };
  const wbook = XLSXS.write(workbook, wopts);
  const blob = new Blob([s2ab(wbook)], { type: "application/octet-stream" });

  function s2ab(s) {
    const buf = new ArrayBuffer(s.length);
    const view = new Uint8Array(buf);
    for (let i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xff;
    return buf;
  }

  return blob;
};
